import { Injectable } from '@angular/core';
import { ApiHttpService } from '../../../shared/services/api_http.service';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { TemplateInstance } from '../models/template-instance.model';

@Injectable()
export class PostmanEditorService {
  constructor(private http: ApiHttpService) {
  }

  updateTemplateMessage(currentMessage, newMessage, reminderId): Observable<TemplateInstance> {
    return this.get(reminderId).pipe(
      concatMap((templateInstance: TemplateInstance) =>
        this.updateTemplateInstance({
          email_type: 'REMINDER',
          email_id: +reminderId,
          compiled_content: templateInstance.compiledContent.replace(currentMessage, newMessage),
          template_content: templateInstance.templateContent.replace(currentMessage, newMessage)
        })
      )
    );
  }

  updateSubjectAndFromLabel(subject: string, storeName: string, reminderId: number) {
    let body = {
      email_type: 'REMINDER',
      email_id: reminderId,
      subject,
      from_label: storeName
    };
    return this.updateEmailSettings(body);
  }

  private updateEmailSettings(emailSettingsUpdateRequest: any): Observable<void> {
    return this.http.patch(`v3/ugc-email-templates/stores/:app_key/email_settings`, emailSettingsUpdateRequest);
  }

  private get(reminderId: string): Observable<TemplateInstance> {
    return this.http.get(`v3/ugc-email-templates/stores/:app_key/email_type/REMINDER/email_id/${ reminderId }/template_instance`);
  }

  private updateTemplateInstance(templateInstanceUpdateRequest: any): Observable<TemplateInstance> {
    return this.http.put(`v3/ugc-email-templates/stores/:app_key/template_instance`, templateInstanceUpdateRequest);
  }
}
